import { Duration } from 'luxon';

export function floorWholeSeconds(totalSeconds: number): number {
  const n = Number(totalSeconds);
  if (!Number.isFinite(n)) {
    return 0;
  }
  return Math.max(0, Math.floor(n));
}

export function formatSecondsToMMSS(totalSeconds: number): string {
  const seconds = floorWholeSeconds(totalSeconds);
  return Duration.fromObject({ seconds }).toFormat('m:ss');
}

export function formatSecondsAdaptiveClock(totalSeconds: number): string {
  const seconds = floorWholeSeconds(totalSeconds);
  const hours = Math.floor(seconds / 3600);
  if (hours > 0) {
    return Duration.fromObject({ seconds })
      .shiftTo('hours', 'minutes', 'seconds')
      .toFormat('h:mm:ss');
  }
  return Duration.fromObject({ seconds }).toFormat('m:ss');
}

export function formatSecondsHumanized(totalSeconds: number): string {
  const seconds = floorWholeSeconds(totalSeconds);
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts: string[] = [];
  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }
  if (secs > 0 || parts.length === 0) {
    parts.push(`${secs}s`);
  }
  return parts.join(' ');
}
